// extracted by mini-css-extract-plugin
module.exports = {"section":"BannerFooter_section__9Vrac","image":"BannerFooter_image__JcuB_"};